//import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
// import Dashboard from './Pages/Dashboard/page';
import Profile from './Pages/Profile/Profile';
import Dashboard from './Pages/Dashboard/page';
import DashboardLayout from './Pages/Dashboard/layout';
import Login from './Pages/Login/Login';
import AddIndustryPage from './Pages/IndustryPage/AddIndustryPage';
import EditIndustryPage from './Pages/IndustryPage/EditIndustryPage ';
import ViewIndustryPageList from './Pages/IndustryPage/ViewIndustryPageList ';
// import ViewRegList from './Pages/RegisteredUsersList/ViewRegList';
import AddUserPage from './Pages/RegisteredUsersList/AddUserPage';
import UserView from './Pages/RegisteredUsersList/UserView';
import UserEdit from './Pages/RegisteredUsersList/UserEdit';

import AddInterestsPage from './Pages/Interests/AddInterestsPage';
import EditInterestsPage from './Pages/Interests/EditInterestsPage ';
import ViewInterestsPageList from './Pages/Interests/ViewInterestsPageList ';

import AddDomainPage from './Pages/Domainmanager/AddDomainPage';  
import EditDomainPage from './Pages/Domainmanager/EditDomainPage';
import ViewDomainPageList from './Pages/Domainmanager/ViewDomainPageList';  
import ViewRegList from './Pages/RegisteredUsersList/ViewRegList';

import AddTestimonialsPage from './Pages/Testimonials/AddTestimonialsPage';
import EditTestimonialsPage from './Pages/Testimonials/EditTestimonialsPage ';
import ViewTestimonialsPageList from './Pages/Testimonials/ViewTestimonialsPageList ';
import TermsEditor from "./Pages/TermsEditor/TermsEditor";
import CookiesEditor from "./Pages/Cookies/CookiesEditor";
import PrivacyPolicy from "./Pages/PrivacyPolicy/PrivacyPolicy";
import AboutUs from "./Pages/AboutUs/AboutUs";
import SocialLinksList from './Pages/SocialLinks/ViewSocialLinks';
import AddSocialLinks from './Pages/SocialLinks/AddSocialLinks';
import EditSocialLinks from './Pages/SocialLinks/EditSocialLinks';



const ProtectedRoute = ({ children }) => {

  const isAuthenticated = !!localStorage.getItem('authUser'); 
  return isAuthenticated ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <>

    <BrowserRouter>
      <Routes>
        {/* <Route path="/" element={  <DashboardLayout><Dashboard /></DashboardLayout> }/> */}
        <Route path="/ViewRegList" element={<ViewRegList/>} />

        <Route path="/" element={ <ProtectedRoute> <DashboardLayout><Dashboard /></DashboardLayout> </ProtectedRoute>}/>
        <Route path="/login" element={<Login/>} />
        {/* <Route path="/" element={ <DashboardLayout>  <Dashboard /> </DashboardLayout>}/> */}
          {/* <Route path="/dasboard" element={<Dashboard/>} /> */}
          <Route path="/profile" element={ <ProtectedRoute>  <Profile/>  </ProtectedRoute>} />
          {/* <Route path="/login" element={<Login/>} /> */}
          
          <Route path="/add-user" element={<ProtectedRoute>  <AddUserPage /> </ProtectedRoute>} />
          <Route path="/user-view/:id" element={<ProtectedRoute> <UserView /> </ProtectedRoute>} />
          <Route path="/edit-user/:id" element={<ProtectedRoute> <UserEdit /> </ProtectedRoute>} />
          <Route path="/add-industry" element={<ProtectedRoute> <AddIndustryPage /> </ProtectedRoute>} />
          <Route path="/edit-industry/:industryId" element={<ProtectedRoute> <EditIndustryPage /> </ProtectedRoute>} /> 
          <Route path="/industries" element={<ProtectedRoute> <ViewIndustryPageList /> </ProtectedRoute>} /> 

          <Route path="/add-interests" element={<ProtectedRoute> <AddInterestsPage /> </ProtectedRoute>} />
          <Route path="/edit-interests/:interestsId" element={<ProtectedRoute> <EditInterestsPage /> </ProtectedRoute>} /> 
          <Route path="/interests" element={<ProtectedRoute> <ViewInterestsPageList /> </ProtectedRoute>} /> 
          
          <Route path="/add-domain" element={<ProtectedRoute> <AddDomainPage /> </ProtectedRoute>} />
          <Route path="/edit-domain/:domainId" element={<ProtectedRoute> <EditDomainPage /> </ProtectedRoute>} />
          <Route path="/domains" element={<ProtectedRoute> <ViewDomainPageList /> </ProtectedRoute>} />

          <Route path="/add-testimonial" element={<ProtectedRoute> <AddTestimonialsPage /> </ProtectedRoute>} />
          <Route path="/edit-testimonial/:testimonialId" element={<ProtectedRoute> <EditTestimonialsPage /> </ProtectedRoute>} /> 
          <Route path="/testimonials" element={<ProtectedRoute> <ViewTestimonialsPageList /> </ProtectedRoute>} />

          <Route path="/termseditor" element={<ProtectedRoute> <TermsEditor /> </ProtectedRoute>} /> 
          <Route path="/cookieseditor" element={<ProtectedRoute> <CookiesEditor /> </ProtectedRoute>} /> 
          <Route path="/privacypolicy" element={<ProtectedRoute> <PrivacyPolicy /> </ProtectedRoute>} />   
          <Route path="/aboutus" element={<ProtectedRoute> <AboutUs /> </ProtectedRoute>} />   

          <Route path="/social-links" element={<ProtectedRoute> <SocialLinksList /> </ProtectedRoute>} />
          <Route path="/add-social-link" element={<ProtectedRoute> <AddSocialLinks /> </ProtectedRoute>} />
          <Route path="/edit-social-link/:linkId" element={<ProtectedRoute> <EditSocialLinks /> </ProtectedRoute>} />
          



        
      </Routes>
    </BrowserRouter>


      
    </>
  );
}

export default App;
